import React from "react";
import { createPortal } from "react-dom";
import { getVerificationStatus, getPaymentMethod } from "./utils";

const SessionActionsDropdown = ({
  openDropdownId,
  dropdownPosition,
  dropdownMenuRef,
  paginateAppointments,
  handleDropdownItemClick,
  handleViewDetails,
  handleVerifyPayment,
  handleCancelSession,
  paymentDataBySession,
  showBillingDetails = false,
}) => {
  if (!openDropdownId) return null;

  const session = paginateAppointments.find((s) => s._id === openDropdownId);
  if (!session) return null;

  const verificationStatus = getVerificationStatus(
    session,
    paymentDataBySession,
  );
  const showVerifyPayment = verificationStatus === "Pending";
  const paymentMethod = getPaymentMethod(
    session,
    paymentDataBySession,
  )?.toLowerCase();
  const verifyActionLabel =
    paymentMethod === "insurance" ? "Verify Insurance" : "Verify Payment";

  return createPortal(
    <div
      ref={dropdownMenuRef}
      className="session-dropdown-menu"
      role="menu"
      aria-label="Session actions"
      style={{
        position: "fixed",
        top: `${dropdownPosition.top}px`,
        left: `${dropdownPosition.left}px`,
        transform: "translateX(-50%)",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        border: "1px solid #e0e0e0",
        padding: "4px 0",
        minWidth: "200px",
        zIndex: 10000,
        overflow: "visible",
        maxHeight: "none",
        pointerEvents: "auto",
        isolation: "isolate",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        role="menuitem"
        tabIndex={0}
        onClick={() => handleDropdownItemClick(handleViewDetails, session)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleDropdownItemClick(handleViewDetails, session);
          }
        }}
        style={{
          fontSize: "14px",
          padding: "8px 16px",
          color: "#000000",
          cursor: "pointer",
          transition: "background-color 0.2s",
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = "#e7f3ff")}
        onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
      >
        View
      </div>
      {showVerifyPayment && !showBillingDetails && (
        <div
          role="menuitem"
          tabIndex={0}
          onClick={() => handleDropdownItemClick(handleVerifyPayment, session)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleDropdownItemClick(handleVerifyPayment, session);
            }
          }}
          style={{
            fontSize: "14px",
            padding: "8px 16px",
            color: "#000000",
            cursor: "pointer",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#e7f3ff")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
        >
          {verifyActionLabel}
        </div>
      )}

      {!showBillingDetails && (
        <div
          role="menuitem"
          tabIndex={0}
          onClick={() => handleDropdownItemClick(handleCancelSession, session)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleDropdownItemClick(handleCancelSession, session);
            }
          }}
          style={{
            fontSize: "14px",
            padding: "8px 16px",
            color: "#000000",
            cursor: "pointer",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#e7f3ff")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
        >
          Cancel Session
        </div>
      )}
    </div>,
    document.body,
  );
};

export default SessionActionsDropdown;
